import { useCallback, useContext, useEffect, useMemo, useState } from 'react';

import { FrequencyDto } from '../../../interfaces/ScheduledJobConfiguration';
import { SchedulingSectionContext } from '../context';

import { UseSchedulingErrorResult } from './useSchedulingError.types';

export const useSchedulingError = (frequency: FrequencyDto): UseSchedulingErrorResult => {
	const { error } = useContext(SchedulingSectionContext);

	const isSchedulingError = useMemo(() => {
		return error && error.payload?.frequency === frequency;
	}, [error, frequency]);

	const [isErrorDismissed, setIsErrorDismissed] = useState(false);

	useEffect(() => {
		if (isSchedulingError) {
			setIsErrorDismissed(false);
		}
	}, [error, isSchedulingError]);

	const showError = isSchedulingError && !isErrorDismissed;

	const dismissError = useCallback(() => {
		setIsErrorDismissed(true);
	}, []);

	return {
		showError,
		errorMessage: error?.message,
		dismissError
	};
};
